import { PencilIcon } from "@heroicons/react/24/outline";
import { IconButton, Modal } from "../../../../../components/ui";
import EditOffer from "./EditOffer";

const Actions = props => {
  const { values } = props || {};
  const { id } = values?.item || values || {};

  const modalProps = {
    body: EditOffer,
    closeOnBackdrop: false,
    offer: values?.item || values || {},
    hideCloseButton: false,
    scale: "lg",
  };

  if (!id) return null;

  return (
    <div className="user-list-actions flex text-right text-sm font-medium">
      <div className="grid">
        <Modal {...modalProps}>
          <IconButton variant="clean" title="Edit Offer">
            <PencilIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
          </IconButton>
        </Modal>
      </div>
    </div>
  );
};

export default Actions;
